const ErrorCodeDictionary = {
    "1000": "errorOccurred",
    "1001": "sessionTimeout",
    "1002": "sessionTimeoutWithErrorCode",
    "1007": "errorOccurred",
    "2001": "loginFailed",
    "2002": "accountClosed",
    "2003": "accountNotExist",
    "2004": "ipRestricted",
    "2005": "accountBlacklisted",
    "3001": "errorOccurred",
    "3002": "userInsufficientFund",
    "3003": "limitBetExceeded",
    "3004": "playerNotPermittedPlay",
    "3005": "errorOccurred",
    "3006": "winLimitHit",
    "3007": "loseLimitHit",
    "3008": "limitBetNotDefined",
    "3009": "limitBetUpdated",
    "3010": "accountSuspended",
    "3013": "accountSuspended",
    "3014": "unavailableGame",
    "3015": "errorOccurredFull",
    "3016": "errorOccurredFull",
    "3017": "errorOccurredFull",
    "4001": "errorOccurred",
    "4003": "errorOccurred",
    "4004": "errorOccurred",
    "4006": "errorOccurred",
    "4007": "errorOccurred",
    "4008": "errorOccurred",
    "4012": "userNotFound",
    "5002": "networkError",
    "5003": "sysMaintenance",
    SB0001: "errorOccurred",
    SB0002: "sessionTimeout",
    SB0003: "playOnOtherDevice",
    SB0004: "serverError",
    SB0005: "invalidData",
    SB0006: "unauthorized",
    SB0007: "serverNotFound",
    SB0008: "accountSignOut",
    SB0009: "dataProcessing",
    SB0010: "connectionFailed",
    SB0011: "sessionExpired",
    SB0012: "nickNameDistance",
    SB0013: "nickNameCharacter",
    SB0014: "nickDifferentUserName",
    SB0015: "existNickName",
    SB1900: "placeBetFailed",
    SB1901: "endGameFailed",
    SB1902: "getBalanceFailed",
    SB1903: "enterPortalFailed",
    SB1904: "jackpotProcessing",
    SB1905: "placeBetNextRound",
    SB1906: "cannotPlaceBet",
    SB1907: "notEnoughMoney",
    SB1908: "notEnoughScoin",
    SB1909: "minBetNotice",
    SB1910: "maxBetForChoiceNotice",
    SB1911: "maxBetNotice",
    SB1912: "invalidHandId",
    SB1913: "handAlreadySplit",
    SB1914: "cantSplitChildHand",
    SB1915: "cantDoubleHand",
    SB1916: "cantHit",
    SB1917: "cardsNotEqual",
    SB1918: "handIsStand",
    SB1919: "invalidPosition",
    SB1920: "handNotActive",
    SB1921: "invalidDealHands",
    SB1922: "processingAction",
    SB1923: "invalidDealDueToRunningRound",
    SB1936: "minBetHand",
    SB1937: "maxStakeHand",
    SB1938: "cantSplitHand",
    SB1924: "maxBetOfAnyChoiceReached",
    SB1925: "betAmountOfAnyChoiceIncorrect",
    SB1926: "invalidBetChoice",
    SB1927: "oneChoiceAllowed",
    SB1928: "invalidPayline",
    SB1929: "invalidFreespin",
    SB1930: "invalidStakeLevel",
    SB1931: "invalidBonus",
    SB1932: "openedBonus",
    SB1933: "gameExcluded",
    SB1934: "notEnoughSpin",
    SB1935: "invalidBet",
    SB1939: "disallowHedgeBet",
};

export const CommonErrorCodeList = [
    "errorOccurred",
    "loginFailed",
    "accountClosed",
    "accountNotExist",
    "ipRestricted",
    "accountBlacklisted",
    "userNotFound",
    "sysMaintenance",
    "networkError",
];

export default ErrorCodeDictionary;
